export const actionTypes = {
  PR_LOADING_START: "PR_LOADING_START",
  PR_LOADING_STOP: "PR_LOADING_STOP",
  PR_LOADING_MORE_START: "PR_LOADING_MORE_START",
  PR_LOADING_MORE_STOP: "PR_LOADING_MORE_STOP",
  PR_SHOW_LIST: "PR_SHOW_LIST",
  PR_APPEND_LIST: "PR_APPEND_LIST",
  PR_ADD_SUCCESS: "PR_ADD_SUCCESS",
  PR_UPDATE_SUCCESS: "PR_UPDATE_SUCCESS",
  PR_DELETE_SOFT: "PR_DELETE_SOFT",
};
